import { useEffect, useState } from 'react';
import { Redirect, Link } from 'react-router-dom'
import { COATitlePage } from './CertificateOfAchievementTitlePage';
import QuestionPage from './Questions/QuestionPage';
import { useLocalisationService } from "providers/LocalisationProvider";
import { MobileWidth } from 'data/consts';

const CertificateOfAchievementStagesEnum = {
  TitlePage:    1, 
  Answering:    2, 
  Summary:      3, 
  Error:        4,
}; 

export const CertificateOfAchievementApp = props => {
  const {location, telemetryService, profile} = props;

  const localisationService = useLocalisationService();

  const [certificate] = useState(location.data ? location.data.certificate : undefined);
  const currStage = location.data ? (location.data.isNew ? CertificateOfAchievementStagesEnum.TitlePage : CertificateOfAchievementStagesEnum.Answering) : CertificateOfAchievementStagesEnum.Error;
  const [stage, setStage] = useState(currStage);
  const [currQuestion, setCurrQuestion] = useState(0);

  const [isMobile] = useState(() => {
    let currentWidth = window.innerWidth;
    return currentWidth < MobileWidth;
  })

  useEffect(() => {
    if(certificate && !certificate.isComplete()){
      const telemetryProps = {
        profile_uuid: certificate.profile().id,
        from_page: certificate.currentQuestion().id()
      };
      telemetryService.reportEvent('app.close', telemetryProps);
    }
  }, [certificate, telemetryService]);

  const getContent = () => {

    if(isMobile){
      return renderMobileError();
    }

    switch (stage){
      case CertificateOfAchievementStagesEnum.TitlePage: 
        return renderTitleScreen();
      case CertificateOfAchievementStagesEnum.Answering:
          return renderQuestionPage();
      case CertificateOfAchievementStagesEnum.Summary:
        return goToSummary();
      default:
        return renderTitleScreen();
    }
  }

  const renderTitleScreen = () => {
    return (<COATitlePage
      profileName={certificate.profile().displayName}
      startAppCallback={startAppCallback}
    />);
  }

  const goToSummary = () => {
    return <Redirect to={ {pathname: '/certificate_of_achivement', certificate} } />;
  }

  const renderMobileError = () => {
    const pcIcon = "/icons/fixit/devices/pc.svg";
    const laptopIcon = "/icons/fixit/devices/laptops.svg";
    const tabletIcon = "/icons/fixit/devices/tablets.svg";
    const iconSize = 90;
    return <div className='mobile-error'>
      <p>{localisationService.getString('mobiles_not_supported')}</p>
      <p>{localisationService.getString('mobile_access_guide')}</p>
      <div className='flexbox centered'>
        <svg width={iconSize} height={iconSize}>       
          <image xlinkHref={pcIcon} width={iconSize} height={iconSize}/>    
        </svg>
        <svg width={iconSize} height={iconSize}>       
          <image xlinkHref={laptopIcon} width={iconSize} height={iconSize}/>    
        </svg>
        <svg width={iconSize} height={iconSize}>       
          <image xlinkHref={tabletIcon} width={iconSize} height={iconSize}/>    
        </svg>
      </div>
      <div className="flexbox centered">
          <Link to='/profiles' className="summary-done">
              <button className="primary-button profile-back-button flexbox centered rounded">{localisationService.getString('homepage_profiles')}</button>
          </Link>
      </div>
    </div>
  }

  const renderQuestionPage = () => {
    return (<QuestionPage 
        numQuestions={certificate.numQuestions()}
        currentQuestion={certificate.currentQuestion()}
        profile={profile}
        goToQuestion={goToQuestionIndex}
      />);
  }

  const goToQuestionIndex = (index) => {
    if(index === currQuestion) return;
    const toQuestion = certificate.question(index);

    const telemetryProperties = {
      profile_uuid: certificate.profile().id,
      from_question: certificate.currentQuestion().id(),
      to_question: toQuestion ? toQuestion.id() : "summary",
      initial_answers: certificate.currentQuestion().savedChoices().map(answer => answer.id()),
      chosen_answers: certificate.currentQuestion().selectedChoices().map(answer => answer.id()),
      // schoool_id,
    }

    telemetryService.reportEvent('cert_of_achievement.change_question', telemetryProperties);
    certificate.goToQuestion(index);
    const nextStage = certificate.isComplete() ? CertificateOfAchievementStagesEnum.Summary : CertificateOfAchievementStagesEnum.Answering;
    setStage(nextStage);
    setCurrQuestion(index);
  }

  const startAppCallback = () => {
    setStage(CertificateOfAchievementStagesEnum.Answering);
    const telemetryProps = {
      profile_uuid: certificate.profile().id,
      language: localisationService.getCurrentLanguage(),
      // schoool_id,
      // class_level,
    };
    telemetryService.reportEvent('cert_of_achievement.started', telemetryProps)
  }

  const css = (stage === CertificateOfAchievementStagesEnum.TitlePage && !isMobile) ? "fixit fixit-title" : "fixit";

  if(!certificate){
    return <Redirect to="profiles"/>
  }

  return (
    <div className={css}>
      {getContent()}
    </div>
  );
};
